export const USER_REQUEST = 'USER_REQUEST'
export const USER_ME_REQUEST = 'USER_ME_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const SET_MY_USER = 'SET_MY_USER'
export const USER_RESET = 'USER_RESET'
